import { ChangeDetectorRef, Component, OnInit,HostListener ,ViewEncapsulation } from '@angular/core';
import { CmsService, OccConfig } from '@spartacus/core';
import { combineLatest, map, Observable } from 'rxjs';
import { ContentService } from '../spartacus/services/content.service';
import { UserInfoService } from '../spartacus/services/user-info.service';

@Component({
    selector: 'app-prescribing-information-uk',
    templateUrl: './prescribing-information-uk.component.html',
    styleUrls: ['./prescribing-information-uk.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class PrescribingInformationUkComponent {
  headerItems$ : Observable<any> = this.cmsService.getComponentData('SeqirusPrescribingFirstComp');
  contentItems$ : Observable<any> = this.cmsService.getComponentData('PrescribingDetailInfoMainComponent');
  prescribingProducts: any = [];
  contentProducts: any = [];
  popupdata: any;
  userLoggedIn: boolean = false;
  sectionIds: string[] = ['aujemsection','aTIVsection','TIVcsection','aqivsection', 'qivcsection'];

  constructor(private accessService: ContentService,private cmsService:CmsService, protected config: OccConfig, private cd: ChangeDetectorRef,protected paraService: ContentService,protected userInfoService: UserInfoService) {}

  ngOnInit() {
    this.headerItems$.subscribe(res => {
      this.productTabs(res);
    })

    this.contentItems$.subscribe(res => {
      this.contentTabs(res);
    })
    this.paraService.getNavigation('PIExternalPopUp').subscribe(res => {
      this.popupdata = res;
    });
    this.userInfoService.userLoggedIn$.subscribe(res=>{
      this.userLoggedIn = res;
    })
  }

  productTabs(res: any) {
    const prodList = res.prescribingList.split(" ");
    const observables = prodList.map((el: any) => this.accessService.opeffeaturedResources1(el));

    combineLatest(observables).pipe(
      map((results:any) => results.flat())
    ).subscribe((mergedResults: any) => {
      this.prescribingProducts = mergedResults;
      this.cd.detectChanges();
    });
  }

  contentTabs(res: any) {
    const contList = res.PDetailedList.split(" ");
    const observables = contList.map((el: any) => this.accessService.opeffeaturedResources1(el));

    combineLatest(observables).pipe(
      map((results:any) => results.flat())
    ).subscribe((mergedResults: any) => {
      this.contentProducts = mergedResults;
      this.cd.detectChanges();
    })
  }

  scrollToSection(sectionId: string, event: Event) {
    event.preventDefault();
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  }

  topFunction() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  }
  openModal() {
    document.body.style.overflowY = 'auto';
    document.getElementById('pi_commonleaving_abandonedPop')!.style.display = 'block';
    this.cd.detectChanges();
  }
  closeModal() {
    document.body.style.overflowY = 'auto';
    document.getElementById('pi_commonleaving_abandonedPop')!.style.display = 'none';
  }

}